import React from "react";

// internal imports
import Header1 from "../../components/Header/Header";
import Navigator from "../../components/Sidebar2/Sidebar2";

// external imports
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";
import colors from "../../theme";

let theme = createTheme({
  palette: {
    primary: {
      light: "#63ccff",
      main: "#009be5",
      dark: "#006db3",
    },
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#0a4243",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.common.white,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          margin: "0 16px",
          minWidth: 0,
          padding: 0,
          "@media (min-width:1200px) and (min-height:1200px)": {
            padding: 0,
            minWidth: 0,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(255,255,255,0.15)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#4fc3f7",
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 14,
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          minWidth: "auto",
          marginRight: theme.spacing(2),
          "& svg": {
            fontSize: 20,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
        },
      },
    },
  },
};

const drawerWidth = 256;

export default function Paperbase() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isSmUp = useMediaQuery("(min-width:600px) and (min-height:600px)");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const pathMapping = {
    "/": "Control Charging",
    "/energy": "Energy",
    "/charging-sessions": "Charging Sessions",
    "/devices": "Manage Charge Points",
    "/card-details": "Card Details",
    "/payment-history": "Payment History",
    "/change-password": "Change Password",
    "/about-us": "About Us",
    "/tariffs": "Tariff",
  };
  const heading = pathMapping[location.pathname] || "RSP";

  return (
    <ThemeProvider theme={theme} sx={{bgcolor: colors.mainContentBgColor}}>
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <CssBaseline />
        <Box
          component="nav"
          sx={{ width: drawerWidth, flexShrink: 0, "@media (max-width:600px), (max-height:600px)": { width: 0 }}}
        >
          {isSmUp ? null : (
            <Navigator
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              handleDrawerToggle={handleDrawerToggle} // Pass the function as a prop
            />
          )}

          <Navigator
            PaperProps={{ style: { width: drawerWidth } }}
            sx={{ display: "none", "@media (min-width:600px) and (min-height:600px)": { display: "block" }}}
            handleDrawerToggle={handleDrawerToggle} // Pass the function as a prop
          />
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", bgcolor: colors.mainContentBgColor }}>
          <Header1 onDrawerToggle={handleDrawerToggle} heading={heading} />
          <Outlet /> {/* Render child routes here */}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
